import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { AppState } from "../../state/AppState";
import { Container, Dropdown, Nav, Navbar, NavDropdown } from "react-bootstrap";
import logo from "../../images/Southland_Logo.png";
import { logOut } from "../../actions/AuthenticationActionCreators";
import PageTitle from "./PageTitle";
import { useUsers } from "../../contexts/users";
import { UserTypes } from "../../models/UserTypes";
import { useCallback } from "react";
import { getSanitizedProviderName } from "../../helper-functions";

export default function Header() {
    const { decodedAccessToken, isAuthenticated } = useSelector((state: AppState) => state.authenticationState);
    const dispatch = useDispatch();
    const {
        userType,
        userState: { loggedInUser },
    } = useUsers();
    const { tenant_name } = decodedAccessToken;
    const isAuthenticatedUser = isAuthenticated && !!tenant_name;
    const isGlobalAdmin = userType === UserTypes.GlobalAdmin;

    const getName = useCallback((): string => {
        if (loggedInUser && (userType === UserTypes.Member || userType === UserTypes.SuperAdmin)) {
            return `${loggedInUser.firstName} ${loggedInUser.lastName}`;
        }

        return getSanitizedProviderName(tenant_name);
    }, [userType, loggedInUser, tenant_name]);

    return (
        <>
            <div className="keysys-header">
                <Navbar collapseOnSelect expand="lg" style={{ height: "130px" }}>
                    <Container>
                        <Navbar.Brand>
                            <Link to="/">
                                <img
                                    src={logo}
                                    alt="Southland Logo"
                                    className="my-2"
                                    style={{ maxWidth: "235px", marginLeft: "-7px" }}
                                />
                            </Link>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="navbarScroll" />
                        <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end bg-white">
                            <Nav>
                                {isAuthenticatedUser && (
                                    <>
                                        <Nav.Item as={Nav.Link} className="d-lg-none text-capitalize">
                                            {getName()}
                                        </Nav.Item>
                                        <Dropdown.Divider className="d-lg-none" />
                                        {userType === UserTypes.Member ? (
                                            <>
                                                <Nav.Link as={Link} to="/my-insurance" eventKey="my-insurance">
                                                    My Insurance
                                                </Nav.Link>
                                                <Nav.Link as={Link} to="/my-claims" eventKey="my-claims">
                                                    My Claims
                                                </Nav.Link>
                                            </>
                                        ) : (
                                            userType !== UserTypes.SuperAdmin && (
                                                <>
                                                    <Nav.Link
                                                        as={Link}
                                                        to="/coverage-inquiry"
                                                        eventKey="coverage-inquiry"
                                                    >
                                                        Coverage Inquiry
                                                    </Nav.Link>
                                                    <Nav.Link as={Link} to="/claim-inquiry" eventKey="claim-inquiry">
                                                        Claim Inquiry
                                                    </Nav.Link>
                                                </>
                                            )
                                        )}
                                        {isGlobalAdmin && (
                                            <>
                                                <Dropdown.Divider className="d-lg-none" />
                                                <Nav.Link as={Link} to="/users" eventKey="users" className="d-lg-none">
                                                    Users
                                                </Nav.Link>
                                                <Nav.Link
                                                    as={Link}
                                                    to="/tenants"
                                                    eventKey="tenants"
                                                    className="d-lg-none"
                                                >
                                                    Tenants
                                                </Nav.Link>
                                                <Dropdown.Divider className="d-lg-none" />
                                            </>
                                        )}
                                        {userType === UserTypes.SuperAdmin && (
                                            <>
                                                <Nav.Link
                                                    as={Link}
                                                    to="/admin-users"
                                                    eventKey="admin-users"
                                                    className="d-lg-none"
                                                >
                                                    Users
                                                </Nav.Link>
                                                <Dropdown.Divider className="d-lg-none" />
                                            </>
                                        )}
                                        {userType === UserTypes.Member && (
                                            <>
                                                <Nav.Link
                                                    as={Link}
                                                    eventKey="locate-dental"
                                                    className="d-lg-none"
                                                    to="/providers/locate/dental"
                                                >
                                                    Locate a Dental Provider
                                                </Nav.Link>
                                                <Nav.Link
                                                    as={Link}
                                                    eventKey="locate-vision"
                                                    className="d-lg-none"
                                                    to="/providers/locate/vision"
                                                >
                                                    Locate a Vision Provider
                                                </Nav.Link>
                                                <NavDropdown title="Locate a Provider" className="d-none d-lg-block">
                                                    <NavDropdown.Item as={Link} to="/providers/locate/dental">
                                                        Dental
                                                    </NavDropdown.Item>
                                                    <NavDropdown.Item as={Link} to="/providers/locate/vision">
                                                        Vision
                                                    </NavDropdown.Item>
                                                </NavDropdown>
                                            </>
                                        )}
                                        <Nav.Link
                                            href="#"
                                            className="d-lg-none"
                                            onClick={() => dispatch(logOut())}
                                            eventKey="logout-mobile"
                                        >
                                            Log Out
                                        </Nav.Link>
                                        <NavDropdown
                                            title={getName()}
                                            className="header-item d-none d-lg-block text-capitalize"
                                        >
                                            {isGlobalAdmin ? (
                                                <>
                                                    <NavDropdown.Item as={Link} to="/users" eventKey="users">
                                                        Users
                                                    </NavDropdown.Item>
                                                    <NavDropdown.Item as={Link} to="/tenants" eventKey="tenants">
                                                        Tenants
                                                    </NavDropdown.Item>
                                                    <Dropdown.Divider className="d-lg-none" />
                                                </>
                                            ) : (
                                                userType === UserTypes.SuperAdmin && (
                                                    <>
                                                        <NavDropdown.Item
                                                            as={Link}
                                                            to="/admin-users"
                                                            eventKey="admin-users"
                                                        >
                                                            Users
                                                        </NavDropdown.Item>
                                                        <Dropdown.Divider />
                                                    </>
                                                )
                                            )}
                                            <NavDropdown.Item onClick={() => dispatch(logOut())}>
                                                Log Out
                                            </NavDropdown.Item>
                                        </NavDropdown>
                                    </>
                                )}
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
                <PageTitle />
            </div>
        </>
    );
}
